import tooltipImg from 'img/tooltip/setup-vigbo-gallery.png';
import React, { type FC, type RefObject } from 'react';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { type ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

import styles from './SetupVigboGalleryTooltip.css';

interface Props {
    target: RefObject<HTMLElement> | Element | null;
    title: string;
    text: string;
    placement: ETooltipPlacement;
    usePortal?: boolean;
    onClose?: () => void;
    onShow?: () => void;
    onClick?: () => void;
}

export const SetupVigboGalleryTooltip: FC<Props> = ({ target, title, text, usePortal, placement, onClose, onClick, onShow }) => {
    return (
        <FloatingTooltip
            target={target}
            placement={placement}
            size={ETooltipSize.fit}
            onClose={onClose}
            onClick={onClick}
            onShow={onShow}
            usePortal={usePortal}
        >
            <div className={styles.root}>
                <div className={styles.textBlock}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.text}>{text}</div>
                </div>
                <img className={styles.image} src={tooltipImg} alt="Картинка в тултипе" />
            </div>
        </FloatingTooltip>
    );
};
